var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"title is-4"},[_vm._v("Commit")]),_c('table',{staticClass:"table is-striped  is-hoverable"},[_c('tbody',_vm._l((_vm.versions),function(ref){
var hash = ref[0];
var number = ref[1];
return _c('tr',{key:hash},[_c('td',[_vm._v(_vm._s(number))]),_c('td',[_vm._v(_vm._s(hash))])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }